import { fetchWorkReports } from './effects';
import { $workReports } from './states';

// Fetch work reports
$workReports.on(fetchWorkReports.doneData, (_, data) => {
    // Copy items
    const itemsCopy = data.items.slice(0);

    return { ...data, items: itemsCopy.filter((i) => i.archived_at === null) };
});
